<template>
    <LexinKeyboardLangContent :layout_content="getLayout()" :lang_header="getHeader()" @add-to-search="addToSearchInput"></LexinKeyboardLangContent>
</template>
<script>

import LexinKeyboardLangContent from "@/components/LexinKeyboardLangContent.vue";

export default {
    props: [],
    components: {
        LexinKeyboardLangContent
    },

    methods: {
        getHeader(){
            return this.$t('message.keyboard-dari');
        },

        getLayout() {
            let layout = {
                default: [
                    '\u0630 \u0632 \u0698 \u0686 \u067E \u06AF \u0634 \u0635 \u0636 \u0637',
                    '\u0638 \u0639 \u063A \u0641 \u0642 \u06A9 \u0644 \u0645 \u0646 \u0648 \u0647 \u064A',
                    '\u0679 \u0688 \u0691 \u06A4 \u06B0 \u06BA \u06C1 \u06C2 \u06C3',
                    '\u06CC \u0621 \u0623 \u0625 \u0624 \u0626 \u0671 \u0670 \u0653 \u0654 \u0655'
                ],
                shift: []
            };

            return layout;
        },

        addToSearchInput(value) {
            this.$emit('add-to-search', value);
        }
    }
}
</script>
